import React from "react";
import { Checkbox } from "react-materialize";
import { useNotify } from "context/NotifyContext";
import handleEvents from "components/notify/handleEvents";

export default function TrHead() {
  const { filters, results, dispatch } = useNotify();
  const checkedAllRemove = handleEvents.CheckboxBulkRemove.IsAllRemove(
    filters?.removeItems,
    results.data
  );
  const columnData = [
    { field: "email", display_name: "EMAIL" },
    { field: "fullname", display_name: "FULL NAME" },
    { field: "name", display_name: "NOTIFICATION TYPE" },
    { field: "senttype", display_name: "TO/CC/BCC" },
    { field: "country", display_name: "COUNTRY" },
    { field: "department", display_name: "DEPARTMENT" },
    { field: "sale_office_code", display_name: "SALES OFFICES" },
    { field: "agent_code", display_name: "AGENT CODE" },
  ];
  let list = [];
  for (const i in columnData) {
    let detail = "";
    list.push(
      <th
        key={"col-" + i}
        className={"th-" + columnData[i].field.toLocaleLowerCase()}
      >
        {columnData[i].display_name}
        {detail}
      </th>
    );
  }
  list.push(
    <th key={"col-" + columnData.length} className={"th-remove"}>
      <span
        style={{
          color: "red",
          display: "block",
          marginBottom: "5px",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={() =>
          handleEvents.CheckboxBulkRemove.OnOpenDialog(filters, dispatch)
        }
      >
        Bulk Remove
      </span>
      <div style={{ paddingLeft: "10px" }}>
        <Checkbox
          checked={checkedAllRemove}
          filledIn
          id={"checkbox-add-remove-items"}
          name=""
          label=""
          className={"checkbox-all-remove-item"}
          value={"all"}
          onChange={(evt) =>
            handleEvents.CheckboxBulkRemove.OnClick(
              evt,
              filters,
              dispatch,
              results.data
            )
          }
        />
      </div>
    </th>
  );
  return <tr key="row-0">{list}</tr>;
}
